import { Link } from '@tanstack/react-router'

import { useT } from '../i18n/index.js'

export function NotFound() {
  const t = useT()
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <p className="t-eyebrow text-[var(--fg-brand)]">404</p>
      <h1 className="mt-2 font-[family-name:var(--mv-font-display)] text-2xl font-bold text-[var(--mv-fg-strong)]">{t('dashboard.notFound.title')}</h1>
      <p className="mt-2 text-sm text-[var(--fg-muted)]">{t('dashboard.notFound.body')}</p>
      <Link to="/" className="mt-6 inline-block text-sm font-semibold text-[var(--mv-blue)]">
        {t('dashboard.notFound.back')}
      </Link>
    </div>
  )
}
